import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Modal from "Components/Generic/Modal";

export const ChangeTaskTimeModal = styled(Modal)(() => ({
  maxWidth: "442px",
}));

export const MultiDayForm = styled(Grid)(() => ({
  marginBottom: "-10px !important",
}));

export const DrawerFooter = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%"
}))
